import { GzHealthDashboardOverviewWebComponent } from './component/GzHealthDashboardOverviewWebComponent';
export { GzHealthDashboardOverviewWebComponent };
